import { WHITE_LABEL_CONFIG } from "@/whiteLable";
import {
  BarChart3,
  BookOpen,
  ClipboardCheck,
  Cog,
  FileText,
  Landmark,
  LayoutDashboard,
  LifeBuoy,
  MessageSquare,
  Settings,
  ShieldCheck,
  UserRoundCheck,
  Users,
} from "lucide-react";
import { App_Url_New } from "../common/static";
import { NavItemType } from "../types/header";

export const HEADER_CONFIG: {
  brand: {
    link: string;
  };
  phone: {
    label: string;
    value: string;
  };
  navigation: NavItemType[];
} = {
  brand: {
    link: App_Url_New.D2CPageUrl.home,
  },

  phone: {
    label: WHITE_LABEL_CONFIG.contact.phoneLabel,
    value: WHITE_LABEL_CONFIG.contact.phoneValue,
  },

  navigation: [
    {
      label: "Insurance",
      children: [
        { label: "Car", path: App_Url_New.D2CPageUrl.insurance.car },
        { label: "Home", path: App_Url_New.D2CPageUrl.insurance.home },
        { label: "Travel", path: App_Url_New.D2CPageUrl.insurance.travel },
        { label: "Health", path: App_Url_New.D2CPageUrl.insurance.health },
        { label: "Life", path: App_Url_New.D2CPageUrl.insurance.lifeGetQuote },
      ],
    },
    {
      label: "Services",
      children: [
        { label: "Claims", path: App_Url_New.CommonPageUrl.services.claims },
        {
          label: "Roadside Assistance",
          path: App_Url_New.CommonPageUrl.services.roadsideAssistance,
        },
        { label: "Complaints", path: App_Url_New.CommonPageUrl.services.complaints },
      ],
    },
    {
      label: "About Us",
      path: App_Url_New.CommonPageUrl.aboutUs,
    },
  ],
};

export const SecureNavBarItems = [
  {
    id: "Dashboard",
    label: "Dashboard",
    icon: LayoutDashboard,
    module: "dashboard",
    path: App_Url_New.B2CPageUrl.dashboard,
    action: "view",
  },
  {
    id: "Pipeline",
    label: "Pipeline",
    icon: BarChart3,
    module: "pipeline",
    path: App_Url_New.B2CPageUrl.pipeline,
    action: "view",
  },
  {
    id: "Client",
    label: "Clients",
    icon: Users,
    module: "clients",
    path: App_Url_New.B2CPageUrl.clients,
    action: "list",
  },
  {
    id: "Communications",
    label: "Communications",
    icon: MessageSquare,
    module: "calls",
    path: App_Url_New.B2CPageUrl.calls,
    action: "view",
  },
  {
    id: "Quotes",
    label: "Quotes",
    icon: FileText,
    module: "quotes",
    path: App_Url_New.B2CPageUrl.quotes,
    action: "view",
  },
  {
    id: "Policies",
    label: "Policies",
    icon: ShieldCheck,
    module: "policies", // Make sure this matches your backend RBAC permission module
    path: App_Url_New.B2CPageUrl.policies, // You will need to add this to your static.ts
    action: "view", // Make sure this matches your backend RBAC action
  },
  {
    id: "Claims",
    label: "Claims",
    icon: ClipboardCheck,
    module: "dashboard",
    path: App_Url_New.B2CPageUrl.claims,
    action: "view",
  },
  {
    id: "Cases",
    label: "Cases",
    icon: LifeBuoy,
    module: "dashboard",
    path: App_Url_New.B2CPageUrl.cases,
    action: "view",
  },
  {
    id: "Commission Dashboard",
    label: "Commission Dashboard",
    icon: Landmark,
    module: "dashboard",
    path: App_Url_New.B2CPageUrl.commissionDashboard,
    action: "view",
  },
  {
    id: "Commission Ledger",
    label: "Commission Ledger",
    icon: BookOpen,
    module: "dashboard",
    path: App_Url_New.B2CPageUrl.commissionLedger,
    action: "view",
  },
  {
    id: "Invoices",
    label: "Invoices",
    icon: FileText,
    module: "dashboard",
    path: App_Url_New.B2CPageUrl.invoices,
    action: "view",
  },

  {
    id: "IRDAI Compliance",
    label: "IRDAI Compliance",
    icon: ShieldCheck,
    module: "dashboard",
    path: App_Url_New.B2CPageUrl.irdaiReports,
    action: "view",
  },
  {
    id: "Settings",
    label: "Settings",
    icon: Settings,
    module: "settings",
    path: App_Url_New.B2CPageUrl.settings,
    action: "view",
  },
  {
    id: "insurer",
    label: "Insurer",
    icon: UserRoundCheck,
    path: App_Url_New.AdminPageUrl.insurer,
    module: "insurerconfig",
    action: "view",
  },
  {
    id: "API Configuration",
    label: "Api Configuration",
    icon: Cog,
    module: "provider-service",
    path: App_Url_New.AdminPageUrl.apiConfiguration,
    action: "list",
  },
  {
    id: "Logs",
    label: "Logs",
    icon: FileText,
    module: "logs",
    path: App_Url_New.AdminPageUrl.logs,
    action: "view",
  },
];
